import React, { useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Banner from '../../components/Banner/Banner';
import Button from '../../components/Button/Button';
import infinity from '../../assets/login/infinity.png';
import logo from '../../assets/logo.png';
import './VerifyCode.css';
import Modal from '../../components/Modal/Modal';
// services
import { authService } from '../../services/login';

const VerifyCode = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [errorResponse, setErrorResponse] = useState(false);
  const [title, setTitle] = useState({ text: 'Verify Code', highlight: 'Request' });
  const [message, setMessage] = useState('A verification code has been sent to your phone number or email address.');
  const navigate = useNavigate();
  const location = useLocation();
  const { formData } = location.state || {};
  const [verificationCode, setVerificationCode] = useState(['', '', '', '', '', '']);
  const [error, setError] = useState('');
  const inputRefs = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null)
  ];

  const handleChange = (value, index) => {
    // Solo permitir números
    if (!/^\d*$/.test(value)) return;

    const newCode = [...verificationCode];
    newCode[index] = value;
    setVerificationCode(newCode);
    setError('');

    // Mover al siguiente input si hay un valor
    if (value !== '' && index < 5) {
      inputRefs[index + 1].current.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    // Mover al input anterior al presionar backspace en un input vacío
    if (e.key === 'Backspace' && verificationCode[index] === '' && index > 0) {
      inputRefs[index - 1].current.focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validar que todos los campos estén llenos y sean números
    const isComplete = verificationCode.every(digit => /^\d$/.test(digit));
    
    if (!isComplete) {
      setError('Please enter a valid 6-digit code');
      return;
    }

    // Aquí iría la lógica para verificar el código
    console.log('Verification code:', verificationCode.join(''));
    try {
      const response = await authService.verifyCode({ code: verificationCode.join(''), email: formData.email });
      console.log('Code verification response:', response);
      if (response.data.status === 'success') {
        setTitle({ text: 'Code', highlight: 'Verified' });
        setMessage('Your code has been verified. Please reset your password.');
        setErrorResponse(false);
        setIsModalOpen(true);
      }
    } catch (error) {
      console.error('Failed to verify code:', error);
      setTitle({ text: 'Error code ', highlight: 'Verification' });
      setMessage(error.response?.data?.message || 'Failed to verify code');
      setErrorResponse(true);
      setIsModalOpen(true);
    }
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    if (errorResponse) return;

    if (title.text === 'Code') {
      navigate('/reset-password', { state: { email: formData.email, code: verificationCode.join('') } });
    }
  };

  const handleResendCode = async () => {
    // Aquí iría la lógica para reenviar el código
    console.log('Resending code...');
    try {
      const response = await authService.forgotPassword({ email: formData.email });
      console.log('Password recovery request sent:', response);
      if (response.status === 'success') {
        setTitle({ text: 'Password Recovery', highlight: 'Request' });
        setMessage('A verification code has been sent to your phone number or email address.');
        setIsModalOpen(true);
      }
    } catch (error) {
      console.error('Failed to send password recovery request:', error);

    }
  };

  return (
    <div className="verify-code-container">
      <div className="verify-code-form-container">
        <img src={logo} alt="Barterflip Logo" className="logo" />
        <h1 className="title">
          VERIFY <span className="highlight">CODE</span>
        </h1>
        <p className="subtitle">
          Enter the code you were sent to your{' '}
          <span className="highlight">Phone or mail</span>
        </p>

        <form onSubmit={handleSubmit} className="verify-code-form" noValidate>
          <div className="code-inputs">
            {verificationCode.map((digit, index) => (
              <input
                key={index}
                ref={inputRefs[index]}
                type="text"
                placeholder="0"
                maxLength={1}
                value={digit}
                onChange={(e) => handleChange(e.target.value, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                className={`code-input ${error ? 'input-error' : ''}`}
              />
            ))}
          </div>
          {error && <span className="error-message-code">{error}</span>}
          
          <div className="resend-code">
            <span>Didn't receive your code?</span>
            <button 
              type="button" 
              className="resend-button"
              onClick={handleResendCode}
            >
              RESEND CODE
            </button>
          </div>

          <Button type="submit" fullWidth>Confirm code</Button>
        </form>
      </div>
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={title}
        showConfirmButton={true}
        confirmText="Confirm"
        onConfirm={handleModalClose}
        message={message}
        error={errorResponse}
      />
      <Banner image={infinity} />
    </div>
  );
};

export default VerifyCode;
